// components/CalendarPanel.js
import React from 'react';
import {
  Paper,
  Typography,
  Button,
  Box,
  Divider,
  IconButton,
  Tooltip
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import {
  NavigateBefore,
  NavigateNext,
  Today,
  CalendarToday
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    flex: '0 0 auto',
    minHeight: '200px',
    maxHeight: '250px',
    display: 'flex',
    flexDirection: 'column',
    // marginBottom: theme.spacing(1),
  },
  statsSection: {
    marginBottom: theme.spacing(2),
  },
  dateSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  dateDisplay: {
    textAlign: 'center',
    flex: 1,
  },
  weekInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  weekBadge: {
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: '0.875rem',
    fontWeight: 'bold',
  },
  todayButton: {
    marginTop: theme.spacing(1),
  },
  filterStats: {
    marginTop: 'auto',
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  statItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
  statLabel: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  statValue: {
    fontWeight: 'bold',
    fontSize: '0.875rem',
  },
}));

const CalendarPanel = ({
  selectedDate,
  onDateChange,
  onPreviousDay,
  onNextDay,
  totalSites,
  filteredStops,
  filteredHours,
  dayOfWeek,
  weekNumber,
  weekType
}) => {
  const classes = useStyles();
  
  const handleTodayClick = () => {
    onDateChange(new Date());
  };
  
  const isToday = moment(selectedDate).isSame(moment(), 'day');
  const dateDisplay = moment(selectedDate).format('MMMM D, YYYY');
  
  return (
    <Paper className={classes.root}>
      {/* Stats Section */}
      <div className={classes.statsSection}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" gutterBottom>
            Schedule Overview
          </Typography>
          {/* Today Button */}
          {!isToday && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<Today />}
              onClick={handleTodayClick}
              className={classes.todayButton}
            >
              Go to Today
            </Button>
          )}
        </div>
        <div className={classes.statItem}>
          <span className={classes.statLabel}>Total Properties:</span>
          <span className={classes.statValue}>{totalSites}</span>
        </div>
      </div>
      
      <Divider />
      
      {/* Date Navigation */}
      <div className={classes.dateSection}>
        <Tooltip title="Previous Day">
          <IconButton onClick={onPreviousDay} size="small">
            <NavigateBefore />
          </IconButton>
        </Tooltip>
        
        <div className={classes.dateDisplay}>
          <DatePicker
            value={selectedDate}
            onChange={onDateChange}
            format="MMM dd, yyyy"
            InputProps={{
              disableUnderline: true,
              style: { textAlign: 'center' }
            }}
          />
        </div>
        
        <Tooltip title="Next Day">
          <IconButton onClick={onNextDay} size="small">
            <NavigateNext />
          </IconButton>
        </Tooltip>
      </div>
      
      {/* Day and Week Info */}
      <Box textAlign="center" mb={2}>
        <Typography variant="h5" gutterBottom>
          {dayOfWeek}
        </Typography>
        
        <div className={classes.weekInfo}>
          <Typography variant="body2" color="textSecondary">
            Week #{weekNumber}
          </Typography>
          <span className={classes.weekBadge}>
            {weekType} Week
          </span>
        </div>
      </Box>
      
      {/* Filter Stats */}
      {/* <div className={classes.filterStats}>
        <div className={classes.statItem}>
          <span className={classes.statLabel}>Filtered Stops:</span>
          <span className={classes.statValue}>{filteredStops}</span>
        </div>
        <div className={classes.statItem}>
          <span className={classes.statLabel}>Filtered Hours:</span>
          <span className={classes.statValue}>
            {Math.round(filteredHours * 100) / 100}
          </span>
        </div>
      </div> */}
    </Paper>
  );
};

export default CalendarPanel;
